export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6125.33036b7d.jpg";